import type { SceneContext } from '@/lib/threeScene/SceneContext';
import { makeMaterial, type MaterialParams } from '@/lib/threeScene/materials/makeMaterial';
import { BackSide, FrontSide } from 'three';

const _colors = {
    /** Bone-color; used for bones. */
    'bone': '#b4aa91',
} as const;

const _materials: Record<string, MaterialParams> = {
    'bone-front': { type: 'standard', color: _colors['bone'], roughness: 1, side: FrontSide },
    'bone-back': { type: 'basic', color: _colors['bone'], side: BackSide },
    'operative-femur-front': {
        type: 'standard',
        color: _colors['bone'],
        opacity: 0.5,
        transparent: true,
        side: FrontSide,
        roughness: 1,
    },
    'operative-femur-back': {
        type: 'standard',
        color: _colors['bone'],
        side: BackSide,
        roughness: 1,
    },
} as const;

/** Create and add overlay-materials to the context */
export function addOverlayMaterials(context: SceneContext) {
    Object.entries(_materials).forEach(([id, params]) =>
        context.addMaterial(id, makeMaterial(params)),
    );
}
